export enum NonceTypesEnum {
  SERIAL,
  TOKEN
}
